module.exports = __webpack_public_path__ + "img/listasPaso.168b34e6.jpg";